/**
 * Visual tokens of the approved rebooking prototype ("A · Columns", PLA-877).
 * Brand values that exist in the theme are re-exported from it; the rest are
 * the prototype's own constants, kept in one place so views never inline them.
 */
import { TextStyle } from "react-native"

import { colors, typography } from "@/theme"

export const tokens = {
  ink: colors.palette.neutral800, // #111E2C
  ink70: "rgba(17, 30, 44, 0.7)",
  ink45: "rgba(17, 30, 44, 0.45)",
  ink32: "rgba(17, 30, 44, 0.32)",
  red: colors.primary,
  redTint: "rgba(255, 56, 47, 0.1)",
  surface: colors.surface,
  mist: colors.palette.neutral200, // #F4F4F4
  modalBorder: colors.palette.modalBorder, // #E5E7EB
  helper: colors.palette.modalHelperText, // #6B7280
  btnBorder: colors.palette.neutral400, // #BDBDBD
  error: "#C62828",
  errorBg: colors.palette.errorBgLight, // #FEF2F2
  field: "#8A8F94",
  okRing: "#008A00",
  ok: "#006B00",
  green: "#00B700",
  greenHalo: "rgba(0, 183, 0, 0.2)",
  line: "#D7D7D7",
  hairline: "#EDEEF0",
} as const

/** 10px pill zone + 4 slots (48) + 3 gaps (8) + 8 gap + 20px peek of the 5th. */
export const COLUMN_MAX_HEIGHT = 254
export const SLIDE_OFFSET = 24
export const SLIDE_MS = 220
/** Horizontal swipe distance that pages the columns. */
export const SWIPE_THRESHOLD = 40

export const font = {
  regular: typography.primary.normal,
  medium: typography.primary.medium,
  semi: typography.primary.semiBold,
  bold: typography.primary.bold,
} as const

export const tabular: Pick<TextStyle, "fontVariant"> = { fontVariant: ["tabular-nums"] }
